import { createTheme } from '@mui/material'

const theme = createTheme({
  palette: {
    primary: {
      main: '#ffe2b6',
    },
    secondary: {
      main: '#ff3f72',
    },
  },
})

export default theme
